import React, { Component } from 'react'

export default class Testtools extends Component {
  render() {
    return (
      <div>
        <section className="colorlib-experience" data-section="timeline">
          <div className="colorlib-narrow-content">
            <div className="row">
              <div className="col-md-6 col-md-offset-3 col-md-pull-3 animate-box" data-animate-effect="fadeInLeft">
                <span className="heading-meta">tools that I use</span>
                <h2 className="colorlib-heading animate-box">Test Tools</h2>
              </div>
            </div>
            <div className="row">
              <div className="col-md-12">
                <div className="timeline-centered">
                  <article className="timeline-entry animate-box" data-animate-effect="fadeInLeft">
                    <div className="timeline-entry-inner">
                      <div className="timeline-icon color-3">
                        <i className="icon-pen2" />
                      </div>
                      <div className="timeline-label">
                        { /* ROBOT FRAMEWORK */ }
                        <h2>Robot Framework <span> open source</span></h2>
                        <p>Robot Framework is open source automation framework. It can be used for test automation and robotic process automation (RPA).
                        It has easy syntax that utilizes human-readable keywords. It can be used for web page automation or REST API testing.
                        Capabilities can be extended with libraries written by Python or Java.
                        Project is hosted on <a href="https://github.com/robotframework/robotframework" target="_blank">GitHub </a> 
                        Want to get started? Documentation can be found <a href="https://robotframework.org/#documentation" target="_blank">here.</a>
                        </p>
                      </div>
                    </div>
                  </article>
                  <article className="timeline-entry animate-box" data-animate-effect="fadeInTop">
                    <div className="timeline-entry-inner">
                      <div className="timeline-icon color-4">
                        <i className="icon-pen2" />
                      </div>
                      {/* XCUITEST */ }
                      <div className="timeline-label">
                        <h2>XCUITest<span> by Apple</span></h2>
                        <p>Xcode comes with the XCUITest framework which allows you to easily develop UI tests for iOS applications. It also includes 
                          UI recording if you are not so comfortable just writing code. Tests can be written with&nbsp;
                          <a href="https://www.swift.com/" target="_blank">Swift </a> or &nbsp;
                          <a href="https://en.wikipedia.org/wiki/Objective-C" target="_blank">Objective C</a>&nbsp;(If you are asking from me use Swift)
                        </p>
                      </div>
                    </div>
                  </article>
                  <article className="timeline-entry animate-box" data-animate-effect="fadeInLeft">
                    <div className="timeline-entry-inner">
                      <div className="timeline-icon color-5">
                        <i className="icon-pen2" />
                      </div>
                      {/* ESPRESSO */ }
                      <div className="timeline-label">
                        <h2>Espresso <span> by Google </span></h2>
                        <p> <a href="https://developer.android.com/training/testing/espresso" target="_blank">Espresso </a> 
                        is a testing framework for Android to write user interface tests. Google released the Espresso framework in 2013.
                        Test recorder is included but code that it generates is almost useless.(yes I have tried it)
                        Tests can be written with&nbsp;<a href="https://www.java.com/en/" target="_blank">Java</a> or&nbsp;
                          <a href="https://kotlinlang.org/" target="_blank">Kotlin</a></p>
                      </div>
                    </div>
                  </article>
                  <article className="timeline-entry begin animate-box" data-animate-effect="fadeInBottom">
                    <div className="timeline-entry-inner">
                      <div className="timeline-icon color-none">
                      </div>
                    </div>
                  </article>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    )
  }
}
